(() => {
	angular.module('main').directive('weekEventCell', weekEventCell);

	weekEventCell.$inject = [
		'$location',
		'timeService',
		'customizeLabelsService'
	];

	function weekEventCell($location, timeService, customizeLabelsService) {
		return {
			restrict: 'AE',
			scope: {
				snData: '=',
				snHour: '=',
				snIndex: '@'
			},
			template: `
                <div class="calendar__item__wrap">
                    <div ng-hide="::cellHeight < 1 || isMainShoot(eventData)" class="calendar__item" style="height:{{::cellHeight}};margin-top:{{::cellOffsetTop}};"
                         ng-class="::{'calendar__item-last': endEventCell}"> 
                        <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>
                        <div class="calendar__item__body">
                            <b class="event__time">
                                 {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}
                            </b>
                            <span>{{::setEventName(eventData)}}</span>
                             <b class="event__type event__type-{{eventColor | lowercase}}"  ng-show="isInLead(eventData)===true">{{::eventType}} (LEAD)</b>
                            <b class="event__type event__type-{{eventColor | lowercase}}"  ng-show="isInLead(eventData)===false || isInLead(eventData)===null">{{::eventType}}</b>
                            </br>
                       
                        </div>
                    </div>
                    
                    <div ng-click="showLead(snData.leadId)" ng-hide="cellHeight < 1 || !isMainShoot(eventData) || isInLead(eventData)===false" class="calendar__item" style="height:{{::cellHeight}};margin-top:{{::cellOffsetTop}};"
                           ng-class="::{'calendar__item-last': endEventCell}"> 
                        <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>
                        <div class="calendar__item__body">
                            <b class="event__time">
                                 {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}
                            </b>
                            <span>{{::setEventName(eventData)}}</span> 
                           <b class="event__type event__type-{{eventColor | lowercase}}"  ng-show="isInLead(eventData)===true">{{::eventType}} (LEAD)</b>
                            <b class="event__type event__type-{{eventColor | lowercase}}"  ng-show="isInLead(eventData)===false">{{::eventType}}</b>
                             </br>
                            
                        </div>
                    </div>
                   
                    <div ng-click="showJob(snData.jobId)" ng-hide="cellHeight < 1 || !isMainShoot(eventData) || isInLead(eventData)===true" class="calendar__item" style="height:{{::cellHeight}};margin-top:{{::cellOffsetTop}};"
                           ng-class="::{'calendar__item-last': endEventCell}"> 
                        <i class="calendar__item__icon jt-big jt-{{::eventData.type | lowercase}}"></i>
                        <div class="calendar__item__body">
                            <b class="event__time">
                                 {{::!eventData.startTime ? ("All day") : (eventData.startTime | timeFilter: "12hLS")}}
                            </b>
                            <span>{{::setEventName(eventData)}}</span> 
                           <b class="event__type event__type-{{eventColor | lowercase}}"  ng-show="isInLead(eventData)===true">{{::eventType}} (LEAD)</b>
                            <b class="event__type event__type-{{eventColor | lowercase}}"  ng-show="isInLead(eventData)===false">{{::eventType}}</b>
                             </br>
                            
                        </div>
                    </div>
                    
                </div>
            `,
			replace: true,
			transclude: true,
			link(scope, elem) {
				let event, rowHeight, rowOffsetTop;
				let currentHour;
				let currentDay,
					startDay,
					endDay,
					startHours,
					endHours,
					eventStartMinutes,
					eventEndMinutes,
					eventStartTime,
					eventEndTime;
				let CELLHEIGHT = 80,
					CELLOFFSETBOTTOM = 10;

				scope.endEventCell = false;
				event = angular.copy(scope.snData);

				currentDay = scope.snHour.time.getDate();
				currentHour = scope.snHour.time.getHours();
				startHours = timeService.getHour(event.startTime);

				if (currentHour === startHours) {
					endDay = timeService.getDay(event.endDate);
					endHours = timeService.getHour(event.endTime);
					eventStartMinutes = timeService.getMinutes(event.startTime);

					eventStartMinutes /= 60;
					eventStartMinutes = parseFloat(eventStartMinutes.toFixed(2));
					eventStartTime = currentHour + eventStartMinutes;

					if (eventStartMinutes) {
						rowOffsetTop = eventStartMinutes;
						rowOffsetTop = `${rowOffsetTop * CELLHEIGHT}px`;
					}

					eventEndMinutes = timeService.getMinutes(event.endTime);
					eventEndMinutes /= 60;
					eventEndMinutes = parseFloat(eventEndMinutes.toFixed(2));

					eventEndTime = endHours + eventEndMinutes;

					if (eventStartTime > eventEndTime && currentDay < endDay) {
						eventEndTime = 24;
					}

					rowHeight = eventEndTime - eventStartTime;

					const cellBottomSpace = Number.isInteger(eventEndTime)
						? CELLOFFSETBOTTOM
						: 0;
					rowHeight = `${rowHeight * CELLHEIGHT - cellBottomSpace}px`;
				}

				if (eventEndTime == 24) {
					scope.endEventCell = true;
				}

				scope.cellHeight = rowHeight || 0;
				scope.cellOffsetTop = rowOffsetTop || 0;

				if (scope.snIndex > 0) {
					elem.addClass(`item-${scope.snIndex}`);
				}

				scope.eventData = event;

				if (scope.eventData) {
					setEventType(scope.eventData);
				}

				scope.isMainShoot = event => event.calendarEventType === 'MAIN_SHOOT';

				scope.isInLead = event => event.inLead;

				scope.setEventName = event => {
					if (!event) {
						return '';
					}
					if (event.typeColor === 'LEAD') {
						return `${event.name}`;
					}
					if (event.jobName && !scope.isMainShoot(event)) {
						return `${event.jobName} - ${event.name}`;
					}
					return event.name;
				};

				function setEventType(event) {
					if (
						event.calendarEventType === 'MAIN_SHOOT' &&
						event.inLead === false
					) {
						scope.eventColor = 'SHOOT';
						scope.eventType = customizeLabelsService.customizeLabels.mainShootLabel.toUpperCase();
					} else if (
						event.calendarEventType === 'MAIN_SHOOT' &&
						event.inLead === true
					) {
						scope.eventColor = 'LEAD';
						scope.eventType = customizeLabelsService.customizeLabels.mainShootLabel.toUpperCase();
					} else if (
						event.calendarEventType === 'EXTRA_SHOOT' &&
						event.inLead === false
					) {
						scope.eventColor = 'SHOOT';
						scope.eventType = customizeLabelsService.customizeLabels.extraShootLabel.toUpperCase();
					} else if (
						event.calendarEventType === 'EXTRA_SHOOT' &&
						event.inLead === true
					) {
						scope.eventColor = 'LEAD';
						scope.eventType = customizeLabelsService.customizeLabels.extraShootLabel.toUpperCase();
					} else {
						scope.eventColor = 'APPOINTMENT';
						scope.eventType = 'APPOINTMENT';
					}
				}

				scope.showJob = function(jobId) {
					$location.path(`jobs/view/${jobId}`);
				};

				scope.showLead = function(leadId) {
					$location.path(`leads/view/${leadId}`);
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/PageCalendar/weekEventCell.js